/** 
 * Internal Page Navigation Block
 * 
 * @class rlInPageNavBlock
 * @memberOf jQuery.fn
**/

(function ($) {
    $.fn.rlInPageNavBlock = function () {
        
        ////////////////////////////////////////////////////////////
        // Is the in page nav below a featured banner block function
        ////////////////////////////////////////////////////////////
        function neighbourchecker() {
            //if next block is a internalpagenavcontainerblock take away margin bottom on featured banner block
            const featurebannerblock = $('.featurebannerblock, .featurebannerpromotionblock');

            featurebannerblock.each(function () {
                const this_el = $(this),
                this_cta_button = this_el.find('.cta-button--primary');

                $(this).attr('aria-hidden', 'false');

                if (this_cta_button.length > 0) {
                    this_cta_button_html = this_cta_button.get(0).outerHTML;
                }

                //campaign page type (top of page)
                if (this_el.parents('.container').next('.container').children('.row').children('div:first-of-type').hasClass('internalpagenavcontainerblock')) {
                  this_el.css('margin', '0').addClass('inpageneighbour');
                  this_el.parents('.container').next('.container').children('.row').children('.internalpagenavcontainerblock:first-of-type').addClass('featuredneighbour');
                }

                //check within content-components
                if (this_el.next('div').hasClass('internalpagenavcontainerblock')) {
                  this_el.css('margin', '0').addClass('inpageneighbour');
                  this_el.next('div').addClass('featuredneighbour');
                }
            });

            //cta button inside sticky inpage nav
            const featuredneighbour = $('.internalpagenavcontainerblock.featuredneighbour');

            if ($('#main-content .campaignPage').length > 0) {

              featuredneighbour.each(function () {

                const inpageneighbour = $(this),
                      primaryfeaturebannercta = inpageneighbour.parents('.container').prev('.container').find('.featurebannerblock.inpageneighbour').find('.cta-button--primary');
                      featurebannercta = inpageneighbour.prev('.featurebannerblock.inpageneighbour').find('.cta-button--primary');      
                
                let this_cta_button_html = 0;

                if (primaryfeaturebannercta.length > 0) {
                  this_cta_button_html = primaryfeaturebannercta.get(0).outerHTML;
                  stickyCTA();
                }
                else if (featurebannercta.length > 0) {
                  this_cta_button_html = featurebannercta.get(0).outerHTML;
                  stickyCTA();
                }

                function stickyCTA() {
                  inpageneighbour.find('nav').append('<div class="ctawrap">' + this_cta_button_html + '</div>');
                  inpageneighbour.find('.mobilemenu').append(this_cta_button_html);
                }

              });

            } 

        }
        neighbourchecker();
        
      const camp_inpagenaveblock = $('#main-content .campaignPage .internalpagenavcontainerblock').first(),
        quicklinks_button = $('#main-content .campaignPage .internalpagenavcontainerblock .mobilemenu .cta-button--secondary'),
        quicklinks_nav = $('#main-content .campaignPage .internalpagenavcontainerblock nav ul'),
        slideToggleTiming = 750,
        scrollToTiming = 450;
        
        /////////////////////////////////////////////////////////
        // Where is the in page nav block?
        // (viewport detection - campaign page template specific)
        /////////////////////////////////////////////////////////
        function foreach_camp_inpagenavblock() {
            camp_inpagenaveblock.each(function () {
                let this_el = $(this),
                    el_wrapper = this_el.find('.wrapper'),
                    el_top = this_el.offset().top,
                    el_height = this_el.innerHeight(),
                    el_bottom = el_top + el_height;

                this_el.addClass('campfirst');

                function sticky_or_no_sticky() {
                    if ($(window).scrollTop() > el_bottom + 10) {
                        this_el.addClass('fixedheader').attr('aria-hidden', 'true');
                        this_el.css('padding-bottom', el_height);
                        el_wrapper.css('top', -el_height);

                        //set cta button inside the featuredbanner partner version of the in page nav block.
                        let this_el_cta_width = this_el.find('.ctawrap').outerWidth(),
                            this_el_cta_height = this_el.find('.ctawrap').outerHeight();
                                
                        this_el.find('ul').css('padding-right', this_el_cta_width + 38);
                        this_el.find('nav').css('min-height', this_el_cta_height + 17);
                    }
                    else {
                        //same as resetsticky function but specific to each block
                        this_el.removeClass('fixedheader').attr('aria-hidden', 'false');
                        this_el.attr('style', '');
                        el_wrapper.attr('style', '');
                        this_el.find('ul, nav').attr('style', '');
                        this_el.find('.mobilemenu').attr('aria-hidden', 'false');
                    }

                    //fix first link jump issue
                    this_el.addClass('no-margin-bottom');
                    if (this_el.find('ul').css('display') !== 'flex') {
                        let stickymobilemenu_height = this_el.find('.mobilemenu').outerHeight() + 60;
                        this_el.next('div').css('margin-top', stickymobilemenu_height);
                    }
                    else {
                        let stickymenu_height = this_el.find('ul').outerHeight() + 60;
                        this_el.next('div').css('margin-top', stickymenu_height);
                    }

                    //accessibility (is the mobile quick links menu hidden or not?)
                    if (this_el.hasClass('fixedheader') && this_el.find('ul').css('display') == 'flex') {
                        this_el.find('.mobilemenu').attr('aria-hidden', 'true');
                    }
                    else if (this_el.hasClass('fixedheader')) {
                        this_el.find('.mobilemenu').attr('aria-hidden', 'false');
                    }
                    else {
                        this_el.find('.mobilemenu').attr('aria-hidden', 'true');
                    }

                }

                sticky_or_no_sticky();
                $(window).scroll(function () {
                    sticky_or_no_sticky();
                });              
            });

        }

        /////////////////////
        ////Layout Fixer
        ////(primarily fixes the horizontal layout if the layout is inconsistent)
        /////////////////////
        function foreach_inpagenavblock() {
            $('.internalpagenavcontainerblock').each(function () {
                const inpageitem = $(this).find('li');
                inpageitem.each(function () {
                    let el_this = $(this),
                        el_title = el_this.find('span.title'),
                        el_svg = el_this.find('span.svg'),
                        el_hover = el_title.find('span.hover'),
                        titleposition = el_title.position(),
                        svgposition = el_svg.position();

                    if (!el_this.hasClass('ctawrap')) {
                        //take margin-left off svg if it has dropped dropped below text.
                        if (svgposition.top == titleposition.top) {
                            el_svg.removeClass('nomargin');
                            el_title.removeClass('nomargin');
                        }
                        else {
                            el_svg.addClass('nomargin');
                            el_title.addClass('nomargin');
                        }
                    }
                });
                //tweak flexbox layout if only one or two block items - use flex-start instead of justify
                if (inpageitem.length == 1 | inpageitem.length == 2) {
                    $(this).find('ul').addClass('flex-start');
                }
            });
        }


        //////////////////////
        // Helper Functions
        //////////////////////
        function resetsticky() {
            camp_inpagenaveblock.removeClass('fixedheader');
            camp_inpagenaveblock.attr('style', '')
            camp_inpagenaveblock.find('.wrapper').attr('style', '');
            quicklinks_nav.attr('style', '');
        }
        function ClickKeyEvents(this_el) {

            //close mobile menu when link is clicked
            if ($(this_el).parents('ul').prev('.mobilemenu').attr('aria-hidden') == 'false') {
              $(this_el).parents('ul').slideToggle(slideToggleTiming);
            }

            /////////////////////
            //smoothscroll to id
            /////////////////////
          let el_hash = $.attr(this_el, 'href'),
            headerHeight = 0,
            iscampaignpage = $('#main-content').children('.standardPage.campaignPage'),
            fromtop_mobile = 75,
            fromtop_large = 110,
            fromtop_else = 90,
            stickymobilemenu_height = 0,
            stickymenu_height = 0,
            bootstrap_md_max = 991.98,
            bootstrap_md_min = 767.98;
                

            //if campaign page type set these variables
            if (iscampaignpage.length > 0) {
                stickymobilemenu_height = camp_inpagenaveblock.find('.mobilemenu').innerHeight() + 20,
                stickymenu_height = camp_inpagenaveblock.find('ul').innerHeight() + 20;
            }

            //scrollto effect
            if (iscampaignpage.length) {
              if ($(window).width() <= bootstrap_md_max) {
                headerHeight = stickymobilemenu_height;
              }
              else {
                headerHeight = stickymenu_height;
              }
            }
            else {
              if ($(window).width() <= bootstrap_md_min) {
                headerHeight = fromtop_mobile;
              }
              else if ($(window).width() <= bootstrap_md_max) {
                headerHeight = fromtop_large;
              }
              else {
                headerHeight = fromtop_else;
              }
            }

            $('html, body').animate({
              scrollTop: $(el_hash).offset().top - headerHeight
            }, scrollToTiming);
            return false;
            
        }

        //////////////////
        //initialisation
        //////////////////
        foreach_inpagenavblock();
        foreach_camp_inpagenavblock();

        ///////////////////////////
        //refire on browser resize
        ///////////////////////////
        $(window).on('resize-end', function () {
            foreach_inpagenavblock();
            resetsticky();
            foreach_camp_inpagenavblock();
        });

        ////////////
        /// Events
        ////////////
        quicklinks_button.on('click', function () {
            //sticky mobile menu toggle button action
            $(this).parent('.mobilemenu').next('ul').slideToggle(slideToggleTiming);
        });

        quicklinks_button.on('keydown', function (e) {
          var keycode = (e.keyCode ? e.keyCode : e.which);
          //spacebar
          if (keycode == 32) {
            e.preventDefault();
            //sticky mobile menu toggle button action
            $(this).parent('.mobilemenu').next('ul').slideToggle(slideToggleTiming);
          }
        });

        const nav_anchor = $('.internalpagenavcontainerblock nav ul li a'),
              nav_cta = $('.internalpagenavcontainerblock nav .ctawrap a');
        let this_el_href;

        nav_anchor.on('click', function () {
          ClickKeyEvents(this);
          this_el_href = $(this).attr('href');
          tabbing();
        });

        nav_anchor.on('keydown', function (e) {
          var keycode = (e.keyCode ? e.keyCode : e.which);
          //spacebar
          if (keycode == 32) {
            e.preventDefault();
            ClickKeyEvents(this);
            this_el_href = $(this).attr('href');
            window.history.replaceState(null, null, this_el_href);
            tabbing();
          }
        });

        nav_cta.on('keydown', function (e) {
          var keycode = (e.keyCode ? e.keyCode : e.which);
          //spacebar
          if (keycode == 32) {
            e.preventDefault();
            window.location.href = $(this).attr('href');
            tabbing();
          }
        });

        //update inpage sticky nav with current inviewport block
        $('.campfirst.fixedheader nav ul li a').removeClass('active');
        if ($('#main-content .campaignPage').length > 0) {
          $(window).scroll(function () {
            let currentcomponentblock = $('#main-content .content-components > div:in-viewport(300)'),
                currentcomponentblockid = currentcomponentblock.attr('id');

            $('.campfirst.fixedheader nav ul li a').removeClass('active');
            $('.campfirst.fixedheader nav ul li a[href="#' + currentcomponentblockid + '"]').addClass('active');

          });
        }
        

        //remove tabindex on main blocks after focus out (tabbing functions last condition)
        $('.content-components div').not('.content-components div div').on('focusout', function () {
          $(this).removeAttr('tabindex');
        });
        $('.content-components div a:empty').on('focusout', function () {
          $(this).removeAttr('tabindex');
        });

        
        function tabbing() {

          if (this_el_href == undefined) { }

          else {
            $(this_el_href).attr('tabindex', '0').focus();
          }

          this_el_href = undefined;

        }

        ///////////////////////////////////////////////////////////////////////////////
        //add an id to all blocks (parent level div) on the page within #main-content
        //in page navigation component needs this in order for editors to (internally)...
        //..link to a particular section on the page
        ///////////////////////////////////////////////////////////////////////////////
        function AddID(this_el) {
          
          blockcount++;

          let attr_id = $(this_el).attr('id');

          if (typeof attr_id == typeof undefined || attr_id == false) {
            $(this_el).attr('id', 'block' + blockcount);
          }
          $(this_el).attr('id', 'block' + blockcount);

        }
        let blockcount = 0;
        //Campaign, Product & Home page template
        $("#main-content .feature-banners").children('div').not('#main-content .feature-banners div div').each(function () {
            AddID(this);
        });
        //Campaign, Product, Home, Standard & Featured Article page template
        $("#main-content .content-components").children('div').not('#main-content .content-components div div').each(function () {
            AddID(this);
        });

        ///////////////////////////////////////////////////
        //IS THE DESTINATION BLOCK DIV IN VIEWPORT FUNCTION
        ///////////////////////////////////////////////////
        (function (global, factory) {
          typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('jquery')) :
            typeof define === 'function' && define.amd ? define(['jquery'], factory) :
              (factory(global.jQuery));
          }(this, (function ($) {
          'use strict';

          $ = $ && $.hasOwnProperty('default') ? $['default'] : $;

          $.extend($.expr.pseudos || $.expr[':'], {
            'in-viewport': $.expr.createPseudo
              ? $.expr.createPseudo(function (argsString) { return function (currElement) { return isInViewport(currElement, getSelectorArgs(argsString)); }; })
              : function (currObj, index, meta) { return isInViewport(currObj, getSelectorArgs(meta[3])); }
          });
          $.fn.isInViewport = function (options) {
            return this.filter(function (i, el) { return isInViewport(el, options); })
          };

          $.fn.run = run;

          function run(args) {
            var this$1 = this;

            if (arguments.length === 1 && typeof args === 'function') {
              args = [args];
            }

            if (!(args instanceof Array)) {
              throw new SyntaxError('isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions')
            }

            args.forEach(function (arg) {
              if (typeof arg !== 'function') {
                console.warn('isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions');
                console.warn('isInViewport: Ignoring non-function values in array and moving on');
              } else {
                [].slice.call(this$1).forEach(function (t) { return arg.call($(t)); });
              }
            });

            return this
          }

          function getScrollbarWidth(viewport) {
            var el = $('<div></div>').css({
              width: '100%'
            });
            viewport.append(el);

            var scrollBarWidth = viewport.width() - el.width();

            el.remove();
            return scrollBarWidth
          }

          function isInViewport(element, options) {
            var ref = element.getBoundingClientRect();
            var top = ref.top;
            var bottom = ref.bottom;
            var left = ref.left;
            var right = ref.right;

            var settings = $.extend({
              tolerance: 0,
              viewport: window
            }, options);
            var isVisibleFlag = false;
            var $viewport = settings.viewport.jquery ? settings.viewport : $(settings.viewport);

            if (!$viewport.length) {
              console.warn('isInViewport: The viewport selector you have provided matches no element on page.');
              console.warn('isInViewport: Defaulting to viewport as window');
              $viewport = $(window);
            }

            var $viewportHeight = $viewport.height();
            var $viewportWidth = $viewport.width();
            var typeofViewport = $viewport[0].toString();

            if ($viewport[0] !== window && typeofViewport !== '[object Window]' && typeofViewport !== '[object DOMWindow]') {

              var viewportRect = $viewport[0].getBoundingClientRect();

              top = top - viewportRect.top;
              bottom = bottom - viewportRect.top;
              left = left - viewportRect.left;
              right = right - viewportRect.left;

              isInViewport.scrollBarWidth = isInViewport.scrollBarWidth || getScrollbarWidth($viewport);

              $viewportWidth -= isInViewport.scrollBarWidth;
            }

            settings.tolerance = ~~Math.round(parseFloat(settings.tolerance));

            if (settings.tolerance < 0) {
              settings.tolerance = $viewportHeight + settings.tolerance; // viewport height - tol
            }

            if (right <= 0 || left >= $viewportWidth) {
              return isVisibleFlag
            }

            isVisibleFlag = settings.tolerance ? top <= settings.tolerance && bottom >= settings.tolerance : bottom > 0 && top <= $viewportHeight;

            return isVisibleFlag
          }

          function getSelectorArgs(argsString) {
            if (argsString) {
              var args = argsString.split(',');

              if (args.length === 1 && isNaN(args[0])) {
                args[1] = args[0];
                args[0] = void 0;
              }

              return {
                tolerance: args[0] ? args[0].trim() : void 0,
                viewport: args[1] ? $(args[1].trim()) : void 0
              }
            }
            return {}
          }

        })));

    }
}(jQuery));
